import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
const StyleGrid = styled(Grid) `
  padding: 10px 0 20px 0;
`;
export const FormikGrid = props => {
    const { children, spacing = 2 } = props;
    return (React.createElement(StyleGrid, Object.assign({ container: true, spacing: spacing }, props), children));
};
export default FormikGrid;
//# sourceMappingURL=FormikGrid.js.map